/**
 * Prevent browser native .validation for required, email, etc.
 */
export default /* @ngInject */ function() {
    return {
        compile: function(element) {
            element.attr('novalidate', 'novalidate');
        }
    };
}



// WEBPACK FOOTER //
// ./forms/directives/no-validate.js